module.exports = __webpack_public_path__ + "static/media/foto10.f3e85d57.png";